// OrdersBaseUrl is a Uri setting, so it serializes with a trailing slash.
export function orderUrl(ordersBaseUrl, orderId, autoPrint = false) {
    const base = String(ordersBaseUrl || "").replace(/\/+$/, "");
    const url = `${base}/orders/${orderId}/wait-for-order`;
    return autoPrint ? `${url}?autoPrint=true` : url;
}
